const logLoadedEnvironment = false;
const errors: { source: string; error: any }[] = [];

function tryAccessEnvironment(
  source: string,
  access: () => { [key: string]: any },
): { [key: string]: any } | undefined {
  try {
    const env = access();

    if (logLoadedEnvironment && env !== undefined) {
      console.debug(`loaded environment variables via '${source}'`, env);
    }

    return env;
  } catch (error) {
    errors.push({ source, error });
  }
}

const env: { [key: string]: any } | undefined =
  tryAccessEnvironment("import.meta.env", () => import.meta.env) ??
  tryAccessEnvironment("process.env", () => process.env);

if (env === undefined) {
  throw new Error(
    `Couldn't access environment variables\n- ` + errors.map(e => `${e.source}: ${e.error}`).join("\n- "),
  );
}

const environment = env as { [key: string]: any };
export { environment as env };
